var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{staticClass:"modal",on:{"mousedown":_vm.close}},[_c('div',{staticClass:"box",style:({ width: _vm.boxWidth + 'px' }),on:{"mousedown":_vm.boxClick}},[_vm._t("default")],2)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }